import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { ListItem } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export function CustomFieldListItemSwitch({ field, fieldValue, label }: CustomFieldListItemProps) {
  const { t } = useTranslation();

  return (
    <ListItem
      preTitle={label ?? field.title}
      title={fieldValue?.value_bool ? t("common:yes") : t("common:no")}
    />
  );
}
